import { cn } from 'libs/classnames';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { FunctionalComponent, h } from 'preact';
import { IconProps } from 'ui/icons/icon';

interface InputProps {
	type?: 'text';
	value: string;
	inputClassName?: string;
	icon: FunctionalComponent<IconProps>;
	onChange: (event: any) => void;
	isEditing?: boolean;
	placeholder?: string;
	id?: string;
	autofocus?: boolean;
}

export const Input: FunctionalComponent<InputProps> = (props) => {
	const {
		id,
		value,
		onChange,
		autofocus,
		icon: Icon,
		placeholder,
		type = 'text',
		inputClassName,
		isEditing = true,
	} = props;

	return (
		<InputContainer>
			<IconContainer>
				<Icon fill={'var(--input-icon)'}/>
			</IconContainer>
			<input
				data-editing={isEditing}
				id={id}
				type={type}
				value={value}
				autofocus={autofocus}
				onChange={onChange}
				disabled={!isEditing}
				className={cn(inputClassName, {[notEditing]: !isEditing})}
				placeholder={placeholder}
			/>
		</InputContainer>
	);
};

const IconContainer = styled.div`
	position: absolute;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
	color: var(--input-icon);
`;
const notEditing = css`
	-webkit-text-fill-color: var(--input-text);
`;
const InputContainer = styled('div')`
	position: relative;
	display: flex;
	align-items: center;
	height: 40px;
	border: 1px solid var(--input-border);
	border-radius: 4px;
	
	input {
		width: 100%;
		height: 100%;
		border: none;
		padding-left: 40px;
		outline: none;
		background: transparent;
		font-style: normal;
		font-weight: normal;
		font-size: 16px;
		line-height: 24px;
		color: var(--input-text);
	
		&:disabled {
			color: var(--input-text);
			opacity: 1;
		}
		
		&::placeholder {
			font-style: normal;
			font-weight: normal;
			font-size: 16px;
			line-height: 24px;
			color: var(--input-placeholder);
		}
	}
`;
